import { TableRadioButton } from 'primeng/table';
import { RadioButtonClickEvent } from 'primeng/radiobutton';
import { Component } from '@angular/core';

@Component({
  selector: 'miq-tableRadioButton',
  template: `
    <label class="container" (click)="onClick($event)">
      <input type="radio" [checked]="checked" />
      <span class="checkmark"></span>
    </label>
  `,
  standalone: false,
})
export class MiqTableRadioButtonComponent extends TableRadioButton {
  onClick(event: RadioButtonClickEvent) {
    super.onClick(event);
  }
}
